export interface PaginatedData<T> {
  data: T[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPage: number;
}
